import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

// Temporary until https://github.com/github/primer/issues/7021 is resolved.
// Replace this component with Primer's CommentFillIcon when it becomes available.
export const CommentFillIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path d="M2.75 1A1.75 1.75 0 0 0 1 2.75v7.5C1 11.216 1.784 12 2.75 12H4v1.543a1.458 1.458 0 0 0 2.487 1.03L9.06 12h4.19A1.75 1.75 0 0 0 15 10.25v-7.5A1.75 1.75 0 0 0 13.25 1Z" />
    </CustomIcon>
  )
}
